var map = {
	"./AddIcon.svg": 667,
	"./Illustration_closepath.svg": 668,
	"./_download.svg": 669,
	"./_edit (2).svg": 1598,
	"./_edit.svg": 1599,
	"./_email.svg": 670,
	"./_filter.svg": 1600,
	"./_group.svg": 1601,
	"./_phase.svg": 1602,
	"./_print.svg": 671,
	"./_trials_list.svg": 1603,
	"./_trials_map.svg": 1604,
	"./_type.svg": 1605,
	"./academic_cancer_logo.svg": 409,
	"./actions/add_doctor.svg": 933,
	"./actions/connect_with_oncologist.svg": 934,
	"./actions/consult_with_us.svg": 935,
	"./actions/ebook.svg": 936,
	"./actions/edit_email.svg": 937,
	"./actions/general.svg": 938,
	"./actions/missing_data.svg": 939,
	"./actions/next_appointment.svg": 940,
	"./actions/next_scan.svg": 941,
	"./actions/phone_login.svg": 942,
	"./actions/search_doctor.svg": 943,
	"./actions/see_all_options.svg": 944,
	"./actions/send_to_doctor.svg": 945,
	"./actions/share_with_doctor.svg": 946,
	"./actions/treatment_experience.svg": 947,
	"./actions/user_intent.svg": 948,
	"./actions_old/add_doctor.svg": 1606,
	"./actions_old/connect_with_oncologist.svg": 1607,
	"./actions_old/consult_with_us.svg": 1608,
	"./actions_old/ebook.svg": 1609,
	"./actions_old/edit_email.svg": 1610,
	"./actions_old/general.svg": 1611,
	"./actions_old/missing_data.svg": 1612,
	"./actions_old/next_appointment.svg": 1613,
	"./actions_old/next_scan.svg": 1614,
	"./actions_old/phone.svg": 1615,
	"./actions_old/search_doctor.svg": 1616,
	"./actions_old/see_all_options.svg": 1617,
	"./actions_old/send_to_doctor.svg": 1618,
	"./actions_old/share_with_doctor.svg": 1619,
	"./actions_old/treatment_experience.svg": 1620,
	"./actions_old/user_intent.svg": 1621,
	"./add_round.svg": 672,
	"./aditional_info.svg": 1622,
	"./ai.svg": 673,
	"./ai_discovery.svg": 674,
	"./analyze.svg": 410,
	"./arrow-circle-black.svg": 289,
	"./arrow-circle-right.svg": 152,
	"./arrow-circle-right_v2.svg": 675,
	"./arrow-circle.svg": 407,
	"./arrow-down.svg": 1623,
	"./arrow.svg": 411,
	"./arrow_back.svg": 1624,
	"./arrow_down.svg": 357,
	"./arrow_drop_down.svg": 676,
	"./arrow_drop_up.svg": 677,
	"./arrow_left.svg": 678,
	"./arrow_left_2.svg": 214,
	"./attention_icon.svg": 679,
	"./back.svg": 680,
	"./backward.svg": 1625,
	"./bell.svg": 1626,
	"./biomarker_tag.svg": 1627,
	"./book_round.svg": 1628,
	"./bullet.svg": 1629,
	"./call_icon.svg": 1630,
	"./capsule.svg": 1631,
	"./cell.svg": 681,
	"./chat.svg": 1632,
	"./chat_bubbles.svg": 1633,
	"./chat_icon.svg": 412,
	"./check.svg": 662,
	"./check_green.svg": 682,
	"./check_orange.svg": 1634,
	"./checkbox.svg": 1635,
	"./checkbox1.svg": 655,
	"./checked_Icon.svg": 683,
	"./checkmark.svg": 1636,
	"./circle_add.svg": 1637,
	"./circle_subtract.svg": 1638,
	"./clock.svg": 1639,
	"./close.svg": 129,
	"./consult_icon.svg": 413,
	"./cycle.svg": 1640,
	"./datepicker.svg": 658,
	"./delete_icon.svg": 229,
	"./delete_x.svg": 664,
	"./dot.svg": 684,
	"./dots.svg": 1641,
	"./down_arrow.svg": 685,
	"./download-pdf.svg": 414,
	"./download.svg": 1642,
	"./drug.svg": 686,
	"./drugs_black.svg": 1643,
	"./edit.svg": 426,
	"./edit_2.svg": 406,
	"./edit_green.svg": 1644,
	"./edit_orange.svg": 1645,
	"./edit_treatment.svg": 257,
	"./email.svg": 687,
	"./email_round.svg": 1646,
	"./email_share.svg": 688,
	"./emojis/bad.svg": 689,
	"./emojis/happy.svg": 690,
	"./emojis/sad.svg": 691,
	"./empty_item.svg": 415,
	"./file.svg": 660,
	"./filter.svg": 1647,
	"./forward.svg": 1648,
	"./gear.svg": 692,
	"./get_trial_location.svg": 1649,
	"./glass-white.svg": 693,
	"./green_arrow.svg": 694,
	"./group.svg": 1650,
	"./hand.svg": 695,
	"./heart.svg": 696,
	"./help.svg": 1651,
	"./hospital.svg": 697,
	"./house.svg": 1652,
	"./important.svg": 1653,
	"./infinity_loader.svg": 1654,
	"./info.svg": 698,
	"./info_icon.svg": 1655,
	"./intake_icon.svg": 515,
	"./keyboard_arrow_right.svg": 516,
	"./keyboard_double_arrow_right.svg": 517,
	"./knobs.svg": 1656,
	"./last_treatment.svg": 699,
	"./leal_logo_2.svg": 338,
	"./leal_logo_round.svg": 1657,
	"./leal_logo_round_small.svg": 1658,
	"./leal_role_chat.svg": 416,
	"./left-align.svg": 1659,
	"./left.svg": 656,
	"./left_arrow.svg": 700,
	"./light_bulb.svg": 408,
	"./link.svg": 701,
	"./list.svg": 1660,
	"./location.svg": 1661,
	"./locationPin.svg": 417,
	"./login-button.svg": 1662,
	"./mag-icon.svg": 702,
	"./map.svg": 1663,
	"./map2.svg": 703,
	"./maps.svg": 704,
	"./menu_board.svg": 1664,
	"./message-text.svg": 1665,
	"./message_chat.svg": 1666,
	"./message_text.svg": 1667,
	"./minus.svg": 1668,
	"./more-circle.svg": 705,
	"./nav_item_arrow.svg": 706,
	"./new.svg": 1669,
	"./next.svg": 418,
	"./notebook.svg": 707,
	"./notification.svg": 708,
	"./overlay-x.svg": 405,
	"./patients.svg": 1670,
	"./people.svg": 709,
	"./phase.svg": 1671,
	"./phase_1.svg": 710,
	"./phase_2.svg": 711,
	"./phase_3.svg": 712,
	"./phase_4.svg": 713,
	"./phone.svg": 949,
	"./pill.svg": 714,
	"./play.svg": 715,
	"./plus.svg": 1672,
	"./previous_treatments.svg": 716,
	"./print.svg": 1673,
	"./profile.svg": 717,
	"./profile_icon.svg": 950,
	"./profile_results.svg": 718,
	"./property.svg": 719,
	"./publication.svg": 720,
	"./ranks/0.svg": 1674,
	"./ranks/1.svg": 1675,
	"./ranks/2.svg": 1676,
	"./ranks/3.svg": 1677,
	"./record_icon.svg": 1678,
	"./refresh.svg": 721,
	"./right.svg": 657,
	"./right_arrow.svg": 722,
	"./round_question.svg": 1679,
	"./scan_date.svg": 723,
	"./schedule_a_call.svg": 724,
	"./search-status.svg": 1680,
	"./search-zoom-in-black.svg": 1681,
	"./search-zoom-in.svg": 419,
	"./search.svg": 1682,
	"./search_big.svg": 725,
	"./search_clinical_trial.svg": 1683,
	"./search_standard_treatment.svg": 1684,
	"./search_text.svg": 290,
	"./send_message.svg": 726,
	"./sentiment_neutral.svg": 727,
	"./sentiment_neutral_v2.svg": 728,
	"./sentiment_satisfied.svg": 729,
	"./sentiment_satisfied_v2.svg": 730,
	"./sentiment_very_dissatisfied.svg": 731,
	"./sentiment_very_dissatisfied_v2.svg": 732,
	"./share.svg": 733,
	"./share_with_doctor.svg": 734,
	"./sort.svg": 735,
	"./star.svg": 1685,
	"./status.svg": 736,
	"./status_2.svg": 663,
	"./success.svg": 737,
	"./support.svg": 1686,
	"./support_white.svg": 518,
	"./survey_popup.svg": 738,
	"./thumb_down.svg": 739,
	"./thumb_up.svg": 740,
	"./thumb_up_with_start.svg": 519,
	"./tick-off.svg": 288,
	"./tick-on.svg": 287,
	"./tina.svg": 1687,
	"./tooltip_lamp.svg": 741,
	"./trash.svg": 661,
	"./trash_orange.svg": 291,
	"./treatment.svg": 1688,
	"./treatment_icon.svg": 1689,
	"./treatments/chemo.svg": 742,
	"./treatments/combo.svg": 743,
	"./treatments/immuno.svg": 744,
	"./treatments/radiation.svg": 745,
	"./treatments/targeted.svg": 746,
	"./trials_list.svg": 747,
	"./trials_map.svg": 748,
	"./type.svg": 1690,
	"./update_profile.svg": 749,
	"./upload.svg": 659,
	"./upload_document.svg": 520,
	"./upload_white.svg": 507,
	"./user.svg": 1691,
	"./user2.svg": 1692,
	"./user3.svg": 750,
	"./userIcon.svg": 1693,
	"./userIconRedDot.svg": 1694,
	"./userLocationPin.svg": 751,
	"./user_button.svg": 752,
	"./user_role_chat.svg": 753,
	"./user_tick.svg": 1695,
	"./v.svg": 754,
	"./visibility.svg": 665,
	"./visibility_off.svg": 666,
	"./wallet.svg": 1696,
	"./watch.svg": 1697,
	"./what.svg": 1698,
	"./x.svg": 119,
	"./x_orange.svg": 755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 932;